// src/components/sections/ButtonSection.js

// src/components/sections/ButtonSection.js
import React from 'react';
import { Link } from 'react-router-dom';

const ButtonSection = ({ content }) => {
  const { 
    buttonText, 
    buttonLink, 
    buttonStyle = 'primary',
    alignment = 'center'
  } = content;

  if (!buttonText || !buttonLink) return null;

  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end'
  };

  const buttonClasses = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
    outline: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-50',
    link: 'bg-transparent text-blue-600 hover:underline'
  };

  return (
    <div className={`flex ${alignmentClasses[alignment]} py-8`}>
      <Link 
        to={buttonLink.startsWith('http') ? buttonLink : `/${buttonLink.replace(/^\//, '')}`} 
        className={`${buttonClasses[buttonStyle]} px-6 py-3 rounded font-bold`}
      >
        {buttonText}
      </Link>
    </div>
  );
};

export default ButtonSection;
